import { Pipe, PipeTransform } from '@angular/core';
import { Base } from '@sb/library/base';

type FileNameFormatType = 'ext' | 'nameOnly';
@Pipe({
    name: 'formatFilename'
})
export class FormatFilenamePipe extends Base implements PipeTransform {
    transform(value: string | null, type: FileNameFormatType = 'nameOnly'): string {
        if (!value) {
            return '';
        }
        const fileName = value.split('.');
        if (type === 'ext') {
            return (fileName.length >= 2 ? fileName[fileName.length - 1] : $localize`:@@CommonNone:None`).toUpperCase();
        }
        return fileName[0];
    }
}
